<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-awsListing',
  components: { PageTable },
}
</script>
